export enum AuthType {
  CREDS = 'credentials',
  TOKEN = 'refresh_token'
}
